import { Component, inject, Inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { VesselDpControl } from '../../dto/vessel-dp-control';

@Component({
  selector: 'dpi-vessel-dp-control-details',
  imports: [MatInputModule, MatFormFieldModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDialogModule],
  templateUrl: './vessel-dp-control-details.component.html',
  styleUrl: './vessel-dp-control-details.component.scss'
})
export class VesselDpControlDetailsComponent {
  readonly dialogRef = inject(MatDialogRef<VesselDpControlDetailsComponent>);
  vesselDpControl: VesselDpControl;
  isToUpdate: boolean;
  isToDelete: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: VesselDpControl) {
    this.vesselDpControl = data;
    this.isToUpdate = false;
    this.isToDelete = false;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onUpdateClick() {
    this.isToUpdate = true;
  }

  onDeleteClick() {
    this.isToDelete = true;
    this.dialogRef.close();
  }

}
